import React, { useState } from 'react';
import Dialog from '../dialog';
import PMBulkPage from '../../pages/pm';

export interface BulkPMPayload {
  header?: string;
  triageCategory?: string;
}

interface BulkPushMessageProps {
  isOpen: boolean;
  close: () => void;
  payload: BulkPMPayload;
}

const BulkPushMessage = ({
  isOpen,
  close,
  payload
}: BulkPushMessageProps): JSX.Element => {
  // Flag to prevent user action from accidentally closing Dialog as it transitions into view
  const [isInTransition, setIsInTransition] = useState(false);

  const handleClose = () => {
    close();
  };

  return (
    <Dialog
      isOpen={isOpen}
      maxWidth="900px"
      onClose={handleClose}
      onOpening={() => setIsInTransition(true)}
      onOpened={() => setIsInTransition(false)}
      canOutsideClickClose={!isInTransition}
      canEscapeKeyClose={!isInTransition}
      className="pb-0"
      forceScrollY
      title={`Send Bulk Push Message to ${payload.header}`}
    >
      <PMBulkPage
        header={payload.header}
        triageCategory={payload.triageCategory}
      />
    </Dialog>
  );
};

export default BulkPushMessage;
